import type { PaymentType } from "@/api/paymentApi";
import type { ScheduledPaymentForm } from "@/types/scheduledPaymentsTypes";
import type { AccountFragmentFragment, PayIdType } from "@/api/generated/graphql";

export const PAYMENT_STATE = {
  NEW: "new",
  VERIFY: "verify",
  CONFIRMED: "confirmed",
};

export type PaymentStateValue = (typeof PAYMENT_STATE)[keyof typeof PAYMENT_STATE];

export interface PaymentForm {
  details: {
    paymentType: PaymentType;
    fromAccount: AccountFragmentFragment | null;
    name: string;
    amount: number | null;
    description: string;
    savePayeeToAddressBook: boolean;
    scheduledPayment: ScheduledPaymentForm;
    state: PaymentStateValue;
  };
  transfer: {
    toAccount: AccountFragmentFragment | null;
  };
  bankTransfer: {
    accountNumber: string;
    bsb: string;
    addressBookId?: string;
  };
  bpay: {
    billerCode: string;
    crn: string;
    verifiedBillerCode: string;
    lastQueriedBillerCode?: string;
    addressBookId?: string;
  };
  payId: {
    identifier: string;
    type?: PayIdType | null;
    verifiedPayIdIdentifier: string;
    lastQueriedIdentifier?: string;
    addressBookId?: string;
  };
  dateTime?: Date | null;
}
